import animationStyles from './styles/product.videoAnimation.module.scss';
import React, { useEffect, useState } from 'react';
import { clsx } from '../../../../utils/clsx';
import { ppData } from '../../configs/ppData.config';
import { Ssvg } from '../../../../Components/react/Ssvg';
import { ArtworkButton } from './ArtworkButton';
import { Labels } from './Labels';
import { useModal } from '../../../../hooks/useModal';
import { PreviewImageModal } from '../../../../Components/react/PreviewImage.modal';
import { MEDIA_BREAKPOINTS } from '../../../../constants/MEDIA_BREAKPOINTS';
import { useSearchParams } from 'react-router-dom';
import { SEARCH_PARAM_KEY_FRAME_COLOR, SEARCH_PARAM_KEY_FRAME_STYLE, SEARCH_PARAM_KEY_LAYOUT } from '../../constants/searchParamKeys';
import { getCornerImg } from './utils/getCornerImg';
import { MainImageDesktop } from './MainImage.desktop';
import { MainImageMobile } from './MainImage.mobile';
import { Overlay } from '../../../../Components/react/Overlay';
import { Thumbnails } from './Thumbnails';
import { ImagePreloadLinks } from './ImagePreloadLinks';
import { sizesMainImage } from './configs/sizes.mainImage';
import { useActiveListOfLayouts } from '../../hooks/useActiveListOfLayouts';
import { layoutValues } from '../../configs/options';
import { isNotNullOrUndef } from '../../../../utils/isNotNullOrUndef';
const isVertical = layoutValues[0][0].shape.includes('vertical');
export const Images = () => {
    const [imgIndex, setImgIndex] = useState(0);
    const [showArtImg, setShowArtImg] = useState(false);
    const [previewIsOpened, openPreview, closePreview] = useModal();
    const [searchParams] = useSearchParams();
    const layouts = useActiveListOfLayouts(searchParams);
    const layout = searchParams.get(SEARCH_PARAM_KEY_LAYOUT) ?? layouts[0].value;
    const frameStyle = searchParams.get(SEARCH_PARAM_KEY_FRAME_STYLE);
    const frameColor = searchParams.get(SEARCH_PARAM_KEY_FRAME_COLOR);
    const imagesObj = ppData.images[layout];
    const images = imagesObj.rooms.map(r => r.url).slice(0, 5);
    const flatPreviews = ppData.flatPreviews?.[layout];
    const hasArtImg = ppData.artImage !== undefined && ppData.artImage.length > 0;
    const isVideo = !ppData.isPersonalized && !(showArtImg && hasArtImg) && !isVertical && imgIndex === 4;
    useEffect(() => {
        setImgIndex(0);
    }, [layout]);
    if (isNotNullOrUndef(flatPreviews)) {
        images[0] = flatPreviews[0];
    }
    else if (imagesObj['3d'].auto !== undefined && imagesObj['3d'].auto.length > 0) {
        images[0] = imagesObj['3d'].auto;
    }
    if (isNotNullOrUndef(flatPreviews)) {
        flatPreviews.forEach((obj, index) => {
            if (index < 1)
                return;
            images[index] = obj;
        });
    }
    const cornerImg = getCornerImg(layout, frameStyle, frameColor);
    cornerImg !== undefined && images.push(cornerImg);
    const mainImg = showArtImg && hasArtImg
        ? ppData.artImage
        : images[imgIndex] ?? images[0];
    const previewImages = hasArtImg
        ? [...images, ppData.artImage]
        : images;
    const setPrevImage = () => {
        setImgIndex(imgIndex > 0 ? imgIndex - 1 : images.length - 1);
    };
    const setNextImage = () => {
        setImgIndex(imgIndex < images.length - 1 ? imgIndex + 1 : 0);
    };
    const setImage = (i) => {
        setImgIndex(i);
        setShowArtImg(false);
    };
    return (React.createElement("div", { className: "pos:r mt:16 mt:0:lg-up w:1/2:lg-up pr:32:lg-up" },
        React.createElement("div", { className: "pos:r pos:sy:xl-up t:16:xl-up" },
            React.createElement("div", { className: "pos:r lh:0 w:100vw w:4/5:md-up w:5/6:lg-up mx:-pw ml:auto:md-up mr:0:md-up" },
                React.createElement("component-wishlist-button", { class: "pos:a z:2 t:0 r:0 d:flex ai:center jc:center bg:white-0.8 lh:1 py:6 py:10:xl-up px:10 px:14:xl-up bdrs:1 cursor:pointer", "data-action": "wishlist-toggle", "data-sku": ppData.sku, "data-id": ppData.id, "data-current-count": ppData.wishNb, "data-title": ppData.originalTitle, "data-handle": ppData.handle, "data-image": ppData.images[layouts[0].value].rooms[0].url, "data-image3d": ppData.images[layouts[0].value]['3d'].auto, "data-url": ppData.url, "data-active": "0", hidden: true },
                    React.createElement("span", { className: "fz:14 fz:18:xl-up ov:h", "data-wish-counter": "" }, ppData.wishNb),
                    React.createElement("span", { className: "wishlist__loader lh:0 ml:6" },
                        React.createElement(Ssvg, { icon: "#icon--heart-empty", className: "wishlist__heart-empty h:16 h:20:xl-up" }),
                        React.createElement(Ssvg, { icon: "#icon--wishlist-color", className: "wishlist__heart-filled h:16 h:20:xl-up" }))),
                React.createElement(ImagePreloadLinks, { images: images.reduce((arr, img) => {
                        if (typeof img === 'string') {
                            arr.push(img);
                        }
                        else if (img.room !== null) {
                            arr.push(img.room);
                        }
                        return arr;
                    }, []), sizes: sizesMainImage }),
                MEDIA_BREAKPOINTS.MD_UP.matches
                    ? React.createElement(MainImageDesktop, { openPreview: openPreview, image: mainImg, isVideo: isVideo })
                    : React.createElement(MainImageMobile, { image: mainImg, isVideo: isVideo, nbOfItems: images.length, currentIndex: imgIndex, setImage: setImage, setPrevImage: setPrevImage, setNextImage: setNextImage }),
                isVideo &&
                    React.createElement(React.Fragment, null,
                        React.createElement("div", { className: clsx('pos:a z:1 t:0 l:0 h:100p w:100p pev:none', animationStyles.videoAnimationOverlay) }),
                        ['Made in USA', '100% Premium Canvas', 'Ready to hang'].map((text, i) => (React.createElement("div", { key: text, className: clsx('pos:a z:2 lh:0 pev:none', animationStyles.videoAnimationTextWrapper, animationStyles[`videoAnimationTextWrapper${++i}`]) },
                            React.createElement("p", { className: clsx('ff:abril-display fw:300', animationStyles.videoAnimationText, animationStyles[`videoAnimationText${i}`]) }, text),
                            React.createElement("div", { className: "d:flex ai:center" },
                                React.createElement("span", { className: clsx('pos:r fx:none', animationStyles.videoAnimationCircle, animationStyles[`videoAnimationCircle${i}`]) }),
                                React.createElement("span", { className: clsx('w:100p fx:1', animationStyles.videoAnimationLine, animationStyles[`videoAnimationLine${i}`]) })))))),
                MEDIA_BREAKPOINTS.LG_UP.matches &&
                    React.createElement(React.Fragment, null,
                        React.createElement("button", { className: "btn:cleared h:48 w:48 bg:white pos:a z:2 t:50p trf:ty:-50p l:-12 bdrs:50p d:flex ai:center jc:center bxsh:2 hover:bxsh:3 trs", onClick: () => {
                                setPrevImage();
                                setShowArtImg(false);
                            } },
                            React.createElement(Ssvg, { icon: "#icon--arrow-slider-left", className: "h:16" })),
                        React.createElement("button", { className: "btn:cleared h:48 w:48 bg:white pos:a z:2 t:50p trf:ty:-50p r:-12 bdrs:50p d:flex ai:center jc:center bxsh:2 hover:bxsh:3 trs", onClick: () => {
                                setNextImage();
                                setShowArtImg(false);
                            } },
                            React.createElement(Ssvg, { icon: "#icon--arrow-slider-right", className: "h:16" }))),
                hasArtImg && !isVideo &&
                    React.createElement(ArtworkButton, { active: showArtImg, toggleActiveFunction: () => { setShowArtImg(!showArtImg); } }),
                ppData.labels !== undefined && !isVideo &&
                    React.createElement(Labels, null)),
            MEDIA_BREAKPOINTS.MD_UP.matches &&
                React.createElement(Thumbnails, { images: images, activeImgIndex: imgIndex, clickHandler: (i) => { setImage(i); } })),
        previewIsOpened &&
            React.createElement(React.Fragment, null,
                React.createElement(Overlay, { closeHandler: closePreview }),
                React.createElement(PreviewImageModal, { activeIndex: showArtImg ? previewImages.length - 1 : imgIndex, listOfImages: previewImages }))));
};
